module.exports = __webpack_public_path__ + "img/FoodexLogo.619955ee.png";